<template>
  <div
    v-if="job"
    class="career-ai-job-card"
    :class="{ 'is-disabled': disabled }"
  >
    <div class="jc-header">
      <div class="jc-text">
        <div class="jc-company">
          {{ job.company_name || job.company || '会社名非公開' }}
        </div>
        <div class="jc-title">{{ job.title || '' }}</div>
      </div>
      <span class="jc-type">{{ employmentType }}</span>
    </div>

    <div class="jc-meta">
      <span v-if="locationLabel">📍 {{ locationLabel }}</span>
      <span v-if="salaryLabel">💴 {{ salaryLabel }}</span>
    </div>

    <div v-if="tags.length > 0" class="jc-tags">
      <span v-for="t in tags" :key="t" class="jc-tag">{{ t }}</span>
    </div>

    <button class="jc-btn" :disabled="disabled" @click="$emit('apply', job)">
      {{ disabled ? 'この求人は終了しました' : '詳細を見る →' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CareerAIJobCard',
  props: {
    job: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    employmentType() {
      return (
        (this.job && this.job.employment_type) ||
        (this.job && this.job.type) ||
        ''
      )
    },
    locationLabel() {
      if (!this.job) return ''
      return (
        this.job.work_municipalities_and_street_address ||
        this.job.location ||
        ''
      )
    },
    salaryLabel() {
      if (!this.job) return ''
      const min = this.job.min_salary_yen
      const max = this.job.max_salary_yen
      if (min && max) {
        return `${formatYen(min)} 〜 ${formatYen(max)}`
      }
      return this.job.salary || ''
    },
    tags() {
      if (!this.job) return []
      // tags フィールドがあればそれを、なければ業種・職種から推測
      // category は内部キー（"career" 等の英語）なので表示しない
      if (Array.isArray(this.job.tags)) return this.job.tags
      const inferred = []
      if (this.job.industry_category_name)
        inferred.push(this.job.industry_category_name)
      if (this.job.occupation_category_name)
        inferred.push(this.job.occupation_category_name)
      if (this.job.employment_type) inferred.push(this.job.employment_type)
      return inferred
    }
  }
}

function formatYen(yen) {
  const n = Number(yen)
  if (!Number.isFinite(n) || n <= 0) return ''
  if (n >= 10000) {
    const man = Math.round(n / 10000)
    return `${man}万円`
  }
  return `${n}円`
}
</script>

<style lang="scss" scoped>
.career-ai-job-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  font-size: 13px;
  transition: box-shadow 0.15s ease;

  &:hover:not(.is-disabled) {
    box-shadow: 0 2px 8px rgb(0 0 0 / 8%);
  }

  &.is-disabled {
    opacity: 0.55;
    background: #f6f6f6;
  }
}

.jc-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.jc-text {
  flex: 1;
  min-width: 0;
}

.jc-company {
  font-size: 11px;
  color: #888;
  margin-bottom: 2px;
}

.jc-title {
  font-weight: 600;
  font-size: 14px;
  color: #222;
  line-height: 1.4;
}

.jc-type {
  background: #e8f5ee;
  color: #2a7a4e;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.jc-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
  color: #555;
  font-size: 12px;
}

.jc-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;
}

.jc-tag {
  background: #f0f4ff;
  color: #4a5fb8;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
}

.jc-btn {
  margin-top: 10px;
  width: 100%;
  padding: 8px 12px;
  background: #008940;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover:not(:disabled) {
    background: #00702f;
  }

  &:disabled {
    background: #b8b8b8;
    cursor: not-allowed;
  }
}
</style>
